export const capitalizeFirstLetter = (subject: string): string => subject.charAt(0).toUpperCase() + subject.slice(1);

export const formatAsPrice = (price: string | null): string | null => {
    if (price && price?.length > 15) {
        return null;
    }

    const regex = /-?\d{1,12}(\.\d{2})?/;
    const locale = 'nl-NL';
    const options = { style: 'currency', currency: 'EUR' };

    if (price && regex.test(price)) {
        if (parseInt(price) > 9999) {
            return new Intl.NumberFormat(locale, { ...options, minimumFractionDigits: 0 })
                .format(Math.ceil(parseFloat(price)));
        }

        if (parseInt(price) > 0) {
            return new Intl.NumberFormat(locale, options).format(parseFloat(price));
        }

        return new Intl.NumberFormat(locale, options).format(0);
    }

    return null;
};

export const replaceAll = (subject: string, replace: string, by: string): string => subject.split(replace).join(by);

export const formatCamelCaseToHumanReadable = (camelCasedString: string): string => {
    if (camelCasedString.length > 80) return camelCasedString;

    let humanReadable = capitalizeFirstLetter(
        camelCasedString
            .replace(/([A-Z])/g, ' $1')
            .trim()
            .toLowerCase(),
    );

    humanReadable = replaceAll(humanReadable, 'w o z', 'WOZ');
    humanReadable = replaceAll(humanReadable, 'e b v', 'EBV');
    humanReadable = replaceAll(humanReadable, 'o b k', 'OBK');

    return humanReadable;
};

export const isEmpty = (stringToCheck: string | null | undefined): boolean =>
    stringToCheck?.length === 0 || stringToCheck === null || stringToCheck === undefined;

export const convertCamelCaseToKebabCase = (subject: string): string =>
    subject
        .split('')
        .map(character => (character === character.toUpperCase() ? '-' + character.toLowerCase() : character))
        .join('');

export const formatAsFixedPeriod = (amountMonths: number): string =>
    amountMonths < 12 ? 'variabel' : `${amountMonths / 12} jaar`;
